/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/statistics.scss';
import Tab from '../../component/Inc/Tab';
import LineChart from '../../component/Inc/LineChart';
import Paging from '../../component/Inc/Paging';

const Progress = () => {
  const lineChartWidth = '100%';
  const lineChartHeight = '200px';
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    //data => title, cnt
    {title: '년별', value: 0},
    {title: '월별', value: 1},
    {title: '과목별', value: 2}
  ];

  const month = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //progress data by year
  const lineChartDataYear = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  //progress data by month
  const lineChartDataMonth = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  return (
    <main className="com_container com_statistics p_progress">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_4">교사별 진행 통계</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>

              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />
            {/* progress by year and month : menu */}
            {(tabIdx === 0 || tabIdx === 1) && (
              <div className="com_calendar_wrap">
                <div className="year">
                  <button className="btn btn_first"></button>
                  <button className="btn btn_prev"></button>
                  <button className="btn_txt">2023</button>
                  <button className="btn btn_next"></button>
                  <button className="btn btn_last"></button>
                </div>
              </div>
            )}
            {/* progress by subject : menu */}
            {tabIdx === 2 && (
              <>
                <div className="com_calendar_wrap has_option">
                  <div className="year ">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023</button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                  <div className="com_count_wrapper">
                    <div className="operators">
                      <div className="operators_label">
                        <span className="operators_count">총 영업자 수</span>
                        <span className="operators_value">98명</span>
                      </div>
                    </div>
                    <div className="turnover">
                      <div className="turnover_label">
                        <span className="turnover_count">총 매출액</span>
                        <span className="turnover_value">46,500,000</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="month_tabs">
                  <section className="com_tab">
                    {month.map((item, idx) => {
                      return (
                        <button key={idx} className={`tab ${idx === 0 ? 'active' : ''}`}>
                          {item}
                        </button>
                      );
                    })}
                  </section>
                </div>
              </>
            )}

            {/* progress by year */}
            {tabIdx === 0 && (
              <div className="year_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataYear} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <div className="check com_radio_wrap gap">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">진행타임</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">취소</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">중단</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">인계</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">종료</label>
                </div>
                <table className="com_board_list type_row_big">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        No
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        교사명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        1월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        2월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        3월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        4월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        5월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        6월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        7월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        8월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        9월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        10월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        11월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        12월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>김홍보305</td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr className="summarized_rows">
                      <td></td>
                      <td className="td_point td_left">
                        <div className="com_red_txt">진행타임</div>
                        취소
                        <br />
                        중단
                        <br />
                        인계
                        <br />
                        종료
                      </td>
                      {[...Array(12)].map((i, idx) => (
                        <td key={idx} className="td_point td_left">
                          <div className="com_red_txt">456</div>
                          64567
                          <br />
                          324
                          <br />
                          64567
                          <br />
                          324
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}

            {/* progress by month */}
            {tabIdx === 1 && (
              <div className="month_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataMonth} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>교사명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>영역</th>
                      <th>
                        취소
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        중단
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        평균 3개월 중단(%)
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        인계
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        종료
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        평균수업 회차 (%)
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        16회 이상 중단
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        첫 수업중단
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 타임
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        매출합
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>홍길동103</td>
                      <td>영어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>홍길동103</td>
                      <td>사탐</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>홍길동103</td>
                      <td>수학</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>홍길동103</td>
                      <td>사탐</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>홍길동103</td>
                      <td>과탐</td>
                      <td>45</td>
                      <td>45</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>8</td>
                      <td>1</td>
                      <td>40</td>
                      <td className="td_point">25</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="td_point">45</td>
                      <td className="td_point">45</td>
                      <td className="td_point">468%</td>
                      <td className="td_point">64</td>
                      <td className="td_point">54</td>
                      <td className="td_point">10.5%</td>
                      <td className="td_point">54</td>
                      <td className="td_point">20</td>
                      <td className="td_point">4614</td>
                      <td className="td_point">313</td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}

            {/* progress by subject */}
            {tabIdx === 2 && (
              <>
                <section className="subject_wrapper">
                  <div className="box">
                    <div className="subject_title">수업다수 (국어)</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">수업다수 (영어)</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">수업다수 (수학)</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">수업다수 (탐구)</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">인센티브</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list ">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">손실타임 (수업수)</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">수업 증가부분</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list ">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="box">
                    <div className="subject_title">총점부분</div>
                    <div className="com_board_list__scroll">
                      <table className="com_board_list ">
                        <colgroup>
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                          <col width="{{ width: 'calc(100% / 5)' }}" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순위</th>
                            <th>교사명</th>
                            <th>수업수2월</th>
                            <th>진행율</th>
                            <th>유지율</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              <button className="btn_link">김교사 103</button>
                            </td>
                            <td>104</td>
                            <td>91</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
                <Paging />
              </>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default Progress;
